const emptyStringToNull = (value: string) => (value === '' ? null : value);

export default emptyStringToNull;
